import { TRACK_EVENTS } from "./constants"

export const emitLocalTrackAdded=(track)=>{
    window.dispatchEvent(new CustomEvent(TRACK_EVENTS.LOCAL_TRACK_ADDED,{detail:track}))
}
export const emitLocalTrackRemoved=(track)=>{
    window.dispatchEvent(new CustomEvent(TRACK_EVENTS.LOCAL_TRACK_REMOVED,{detail:track}))
}
export const emitLocalTrackMuteChanged=(track)=>{
    window.dispatchEvent(new CustomEvent(TRACK_EVENTS.LOCAL_TRACK_REMOVED,{detail:track}))
}

export const emitRemoteTrackAdded=(track)=>{
    window.dispatchEvent(new CustomEvent(TRACK_EVENTS.REMOTE_TRACK_ADDED,{detail:track}))
}
export const emitRemoteTrackRemoved=(track)=>{
    window.dispatchEvent(new CustomEvent(TRACK_EVENTS.REMOTE_TRACK_REMOVED,{detail:track}))
}
export const emitRemoteTrackMuteChanged=(track)=>{
    window.dispatchEvent(new CustomEvent(TRACK_EVENTS.REMOTE_TRACK_MUTE_CHANGED,{detail:track}))
}

export const emitScreenshareTrackAdded=(track)=>{
    window.dispatchEvent(new CustomEvent(TRACK_EVENTS.SCREEN_SHARE_TRACK_ADDED,{detail:track}))
}

export const emitScreenshareTrackRemoved=(track)=>{
    window.dispatchEvent(new CustomEvent(TRACK_EVENTS.SCREEN_SHARE_TRACK_REMOVED,{detail:track}))
}

export const emitScreenshareTrackMuteChanged=(track)=>{
    window.dispatchEvent(new CustomEvent(TRACK_EVENTS.SCREEN_SHARE_TRACK_MUTE_CHANGED,{detail:track}))
}

export const emitTrackStreamingStatusChanged=(track,status)=>{
    window.dispatchEvent(new CustomEvent(TRACK_EVENTS.TRACK_STATUS_CHANGED,{detail:{track,status}}))
}
